import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import * as Dialog from 'components/dialog';

const stripePromise = loadStripe(import.meta.env.VITE_DASHBOARD_STRIPE_CASHIER_KEY);

interface StripeCheckoutDialogProps extends Dialog.DialogProps {
    clientSecret: string | null;
    showOverlay?: boolean;
    onComplete?: () => void;
}

const StripeCheckoutDialog = (props: StripeCheckoutDialogProps) => {
    const { clientSecret, showOverlay = false, onComplete, children, ...rest } = props;

    return (
        <Dialog.Root {...rest}>
            {children}
            <Dialog.Portal>
                {showOverlay && <Dialog.Overlay />}
                <Dialog.Content className="p-0">
                    <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={{ clientSecret, onComplete }}
                    >
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

const Root = StripeCheckoutDialog;
const StripeCheckoutDialogTrigger = Dialog.Trigger;
const StripeCheckoutOverlay = Dialog.Overlay;
const Trigger = StripeCheckoutDialogTrigger;
const Overlay = StripeCheckoutOverlay;

export {
    Root,
    Trigger,
    Overlay,
    StripeCheckoutDialog,
    StripeCheckoutDialogTrigger,
    StripeCheckoutOverlay,
};
